
























































































































































































































































import mixins from 'vue-typed-mixins';
// import I18nMixin from "@/Shared/I18nMixin";
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import BuildEntityComponent from '@/Shared/CommonEntityMixins/EntityComponentMixin';
import {Citation} from '../Citation';
import MonthSelector from '@/Shared/MonthSelector.vue';

const component = mixins(
    LocationBasedMixin,
    BuildEntityComponent<Citation>()
).extend({
    components: {
        MonthSelector,
    },
    data() {
        return {
            i18nPrefix: 'citation.issueTicket',
            expiryMonth: null as number | null,
            expiryYear: null as number | null,
        };
    },
    computed: {
        entityUrls() {
            return `${this.location}/issueTicket/issueTicket`;
        },
        years() {
            const year = new Date().getFullYear();
            return Array.from(
                {length: year - 2000},
                (_, index) => year - 15 + index
            );
        },
    },
    methods: {
        async saveTicket() {
            if (this.expiryMonth && this.expiryYear) {
                this.entity.licenseExpireDate =
                    this.expiryMonth.toString().padStart(2, '0') + this.expiryYear;
            }

            // await because saveEntity will set the entity to the response data
            // which would un-reset the form
            await this.saveEntity();

            // alert successful save
            const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.saveSuccessTitle`);
            const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.saveSuccessMessage`);
            this.$bvToast.toast(translatedMessage.toString(), {
                title: translatedTitle.toString(),
                autoHideDelay: 5000
            });

            this.resetForm();
        },
        resetForm() {
            this.entity = {} as Citation;
        },
    },
});

export default component;
